import {
  ASYNC_FETCH,
  ASYNC_FETCH_SUCCESS,
  ASYNC_FETCH_FAILURE,
  SET_ISCONFIRM_LOAD
} from '../constants';

import httpClient, { getHttpClientRequest, postHttpClientRequest } from "../../../shared/services/httpClient";
import apiUrl from '../../../shared/utilities/apiUrl';

export const getSections = (postData) => dispatch => {
  dispatch(asyncFetch());

  const onSuccess = response => {
    dispatch(asyncFetchSuccess(response.data));
  };

  const onError = error => {
    dispatch(asyncFetchFailed(error));
  };
  const callMS = (postData) => {
    console.log("Api url==" + apiUrl().generateRemarksUrl);
    var axConfig = {
      headers: { pageName: "confirmation", subServiceName: "confirmation" }
    };
    
    if (apiUrl().generateRemarksUrl.indexOf("localhost") > -1) {
      return getHttpClientRequest(apiUrl().generateRemarksUrl, axConfig);
    } else {
      return postHttpClientRequest(
        apiUrl().generateRemarksUrl,
        postData,
        axConfig
      );
    }

  };

  callMS(postData)
    .then(msResp => {
      if (msResp && msResp.status == 200) {
        onSuccess(msResp);
      } else {
        onError(msResp);
      }
    })
    .catch(onError);
};

export const asyncFetch = urlParams => ({
  type: ASYNC_FETCH,
  urlParams
});
export const asyncFetchSuccess = msResp => ({
  type: ASYNC_FETCH_SUCCESS,
  msResp
});
export const asyncFetchFailed = err => ({
  type: ASYNC_FETCH_FAILURE,
  err
});

export const setisConfirmLoadValue = data => ({
  type: SET_ISCONFIRM_LOAD,
  data
});

